const switchConsole = () => {
    return dispatch => {
        dispatch({type: 'SWITCH_CONSOLE'});
    }
}
export { switchConsole }